import React, {useState, useCallback} from 'react';
import {connect} from 'react-redux';
import ReactBootstrapSlider from 'react-bootstrap-slider';
import {changeVolume} from 'engine/mix/actions.js';

const MIN_VOLUME = -70;
const MAX_VOLUME = 6;

const WorkVolume = ({masterVolume, id, multiSequencerEngine, sequencerEngine}) => {
    const volume = getVolumeRatio(masterVolume);
    const onChange = useCallback((e) => {
        let volume = getVolumeFromRatio(e.target.value);
        multiSequencerEngine.
            dispatch(
                changeVolume(
                    sequencerEngine.sequenceId,
                    volume));
    }, [sequencerEngine, multiSequencerEngine]);

    return (
        <div className="work-volume-container">
          <ReactBootstrapSlider
            value={volume}
            change={onChange}
            step={0.01}
            className="work-fader"
            max={1}
            min={0}
            orientation="vertical"
            reversed={true}/>
        </div>
    );
};

function getVolumeFromRatio(ratio, min=MIN_VOLUME, max=MAX_VOLUME) {
    let fullRatio = Math.pow(ratio, 1.0/4.0);
    return min + (max - min) * fullRatio;
}

function getVolumeRatio(volume, min=MIN_VOLUME, max=MAX_VOLUME) {
    return Math.pow((volume - min) / (max - min), 4.0);
}

const mapStateToProps = (state, props) => {
    return {
        masterVolume: state.sequencer.masterVolumes[props.id]
    };
};

export default connect(mapStateToProps, null)(WorkVolume);

